import OnboardingScheduler from "vcomponents/pages/onboarding/scheduler/OnboardingScheduler.vue";
import OnboardingSchedulerConfirmed from "vcomponents/pages/onboarding/scheduler/OnboardingSchedulerConfirmed.vue";

export default [
    {
        path: '/onboarding/scheduler',
        name: 'onboarding.scheduler',
        component: OnboardingScheduler,
        props: true
    },
    {
        path: '/scheduler-confirmed',
        name: 'onboarding.scheduler.confirmed',
        component: OnboardingSchedulerConfirmed,
    }
]